import { createI18n } from "vue-i18n";
import { vuetifyLocaleMap } from './vuetify-generated'

function loadLocaleMessages() {
    const modules = import.meta.glob("./**/*.json", { eager: true, import: "default" });
    const messages = {};
    for (const path in modules) {
        const match = path.match(/\/([A-Za-z0-9-_]+)\.json$/i);
        if (match) {
            const locale = match[1];
            messages[locale] = modules[path];
        }
    }
    for (const localeKey of Object.keys(messages)) {
        const base = localeKey.split('-')[0];
        const vuetifyMsg = vuetifyLocaleMap[localeKey] || vuetifyLocaleMap[base];
        if (vuetifyMsg) {
            messages[localeKey] = { $vuetify: vuetifyMsg, ...messages[localeKey] };
        }
    }
    return messages;
}

export default createI18n({
    legacy: false,
    locale: localStorage.getItem('lang') || 'en',
    fallbackLocale: 'en',
    messages: loadLocaleMessages(),
});
